import { render, staticRenderFns } from "./bulk-message-template-view-all-dialog.vue?vue&type=template&id=1480750d&scoped=true&"
import script from "./bulk-message-template-view-all-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-view-all-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480750d",
  null
  
)

export default component.exports